import { useEffect, useState } from "react";
import { Link2, Share2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";

interface ArticleShareProps {
  title: string;
  excerpt?: string;
}

export const ArticleShare = ({ title, excerpt }: ArticleShareProps) => {
  const isMobile = useIsMobile();
  const [canNativeShare, setCanNativeShare] = useState(false);

  useEffect(() => {
    setCanNativeShare(typeof navigator !== "undefined" && typeof navigator.share === "function");
  }, []);

  const getUrl = () => (typeof window !== "undefined" ? window.location.href : "");

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(getUrl());
      toast.success("Link copiato negli appunti");
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  const handleWhatsApp = () => {
    const url = `https://wa.me/?text=${encodeURIComponent(`${title} ${getUrl()}`)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleNativeShare = async () => {
    try {
      await navigator.share({ title, text: excerpt, url: getUrl() });
    } catch {
      // user cancelled or unsupported, ignore
    }
  };

  return (
    <div className="mt-12 pt-8 border-t border-border">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <span className="font-body text-sm uppercase tracking-wider text-muted-foreground">
          Condividi questo articolo
        </span>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={handleCopy}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-border hover:border-gold/50 hover:text-gold transition-colors text-sm font-body"
            aria-label="Copia link"
          >
            <Link2 size={16} />
            Copia link
          </button>
          {isMobile && (
            <button
              onClick={handleWhatsApp}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-border hover:border-gold/50 hover:text-gold transition-colors text-sm font-body"
              aria-label="Condividi su WhatsApp"
            >
              <MessageCircle size={16} />
              WhatsApp
            </button>
          )}
          {isMobile && canNativeShare && (
            <button
              onClick={handleNativeShare}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-border hover:border-gold/50 hover:text-gold transition-colors text-sm font-body"
              aria-label="Condividi"
            >
              <Share2 size={16} />
              Condividi su
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
